import React from "react";

const FaqComponent = () => {
  return (
    <div
      className="mx-auto mt-32 max-w-4xl px-4 md:px-0"
      style={{ paddingBottom: "50px" }}
    >
      <div className="text-left">
        <h2 className="text-2xl font-bold text-gray-900">
          Frequently Asked Questions
        </h2>
      </div>
      <div className="grid w-full grid-cols-1 mx-auto mt-10 sm:mt-10 md:grid-cols-2 gap-8">
        {cellView(
          "What is store credit, and how is it different from a discount?",
          "A discount reduces the price of an order for any customer. Store credit is money in a specific customer account. The customer uses it on a future order. Store credit keeps the revenue inside your business. A discount does not."
        )}
        {cellView(
          "How does cashback work for my customers?",
          "After each purchase, Pabloo adds a percentage of the order value to the customer account as store credit. The customer uses this credit on the next order. You set the cashback rate in the Pabloo dashboard."
        )}
        {cellView(
          "Does Pabloo work with Shopify's native checkout?",
          "Yes. Pabloo is a Built for Shopify app. It works with Shopify's native checkout. Customers see their store credit balance at checkout and apply it to the order in one step."
        )}
        {cellView(
          "How much does switching refunds to store credit save?",
          "Pabloo merchants save an average of $21,000 per year. You also eliminate payment processing fees on refunds. The average member saves about 7% of their annual GMV."
        )}
        {cellView(
          "What if a customer wants a cash refund instead of store credit?",
          "You stay in control. You set the rules for when store credit is available. You can offer store credit as an option, not a requirement. The customer chooses."
        )}
        {cellView(
          "Can I import customer balances from another loyalty app?",
          "Yes. Use the customer import tool in the Pabloo dashboard to upload existing balances. The import tool accepts a CSV file."
        )}
        {cellView(
          "Which platforms does Pabloo support?",
          "Pabloo works with Shopify and WooCommerce. It also has a public SDK for custom development. Contact the team if you use a different platform."
        )}
        {cellView(
          "Is there a free trial?",
          "Yes. Every new account starts with a 14-day free trial. You do not need a credit card to start."
        )}
        {cellView(
          "Is my payment information secure?",
          "Yes. Pabloo uses Stripe to process payments. Pabloo does not store your payment information."
        )}
      </div>
    </div>
  );

  function cellView(text, subtext) {
    return (
      <div>
        <p className="text-base font-semibold text-black">{text}</p>
        {typeof subtext === "string" ? (
          <p className="mt-3 text-sm text-gray-600">{subtext}</p>
        ) : (
          <div className="mt-3 text-sm text-gray-600">{subtext}</div>
        )}
      </div>
    );
  }
};

export default FaqComponent;
